import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function error404Animation() {
	const container = document.querySelector("#error-404-svg");
	if (!container) return;

	const targets = Array.from(container.querySelectorAll(".rotateY-on-hover--target"));
	const triggers = Array.from(container.querySelectorAll(".rotateY-on-hover--trigger"));

	if (!targets.length) return;

	// Function to run the animation
	const runAnimation = () => {
		gsap.fromTo(
			targets,
			{ "--rotY": "180deg" },
			{
				"--rotY": "0deg",
				duration: 0.28,
				ease: "power2.out",
				stagger: 0.18,
				onComplete: () => {
					// Re-enable CSS transitions and hover after animation completes
					targets.forEach(t => {
						t.style.removeProperty("--rotY");
						t.style.transition = '';
					});
					triggers.forEach(trigger => {
						trigger.style.pointerEvents = '';
					});
				}
			}
		);
	};

	// Disable CSS transitions and hover during initial animation
	targets.forEach(tt => {
		tt.style.transition = 'none';
		tt.style.setProperty("--rotY", "180deg");
	});

	// Disable pointer events on triggers during animation
	triggers.forEach(trigger => {
		trigger.style.pointerEvents = 'none';
	});

	// Use a small delay to ensure everything is loaded
	setTimeout(() => {
		ScrollTrigger.create({
			trigger: container,
			start: "top bottom-=200px",
			once: true,
			onEnter: runAnimation
		});

		// Check if already in view and trigger immediately
		ScrollTrigger.refresh();
	}, 100);
}

export default error404Animation;
